declare function zE(widget: string, action: string, ...args: unknown[]): void;

export function loginZendeskMessenger(getJwt: () => Promise<string>): void {
    if (typeof zE === 'undefined') return;

    zE(
        'messenger',
        'loginUser',
        async (callback: (jwt: string) => void) => {
            try {
                const jwt = await getJwt();
                callback(jwt);
            } catch (error) {
                console.error('Failed to get Zendesk JWT:', error);
            }
        },
        (error: unknown) => {
            if (error) console.error('Failed to login to Zendesk Messenger:', error);
        }
    );
}

export function logoutZendeskMessenger(): void {
    if (typeof zE === 'undefined') return;

    // Best effort, so a Messenger failure cannot stop the panel logout that follows.
    try {
        zE('messenger', 'logoutUser');
    } catch (error) {
        console.error('Failed to log out of Zendesk Messenger:', error);
    }
}

/**
 * Resolve once the Zendesk snippet has run or failed to load, after which `zE` is defined only if Messenger is
 * enabled and reachable. The snippet is a parser-blocking script emitted after the page bundle, so code running
 * at mount can precede it; `DOMContentLoaded` never does.
 */
export function whenZendeskSnippetReady(): Promise<void> {
    if (document.readyState !== 'loading') return Promise.resolve();

    return new Promise((resolve) => {
        document.addEventListener('DOMContentLoaded', () => resolve(), { once: true });
    });
}
